export class GetUsers {

  id: string;
  fullName: string;
  department: string;
  email: string;
  phone: string;
  mobile: string;

}
